module.exports = __webpack_public_path__ + "img/schoolMotto.e2b65196.png";